export default "__VITE_ASSET__nFwf3aFm__"